import React, { useEffect, useState } from 'react';
import { addDays, endOfDay, startOfDay } from 'date-fns';

import { BookingScreens } from './BookingStates';
import { EXAM_CENTERS_CONFIG } from '../../constants';
import BookingCalendar from '../calendar/BookingCalendar';
import { ChosenSlot } from './ChosenSlot';
import { LoggedInPayment } from '../LoggedInPayment';
import { RegistrationTabs } from './RegistrationTabs';
import { ErrorScreen } from './ErrorScreen';
import { LoadingScreen } from './LoadingScreen';
import { LicenseSwitcher } from './LicenseSwitcher';
import { ChosenLicenseType } from './ChosenLicenseType';
import stores from '../../stores';

const {
  BOOKING_ERROR, REGISTRATION_TABS, SLOTS, USER_INFO, LOADING, LICENSE_TYPE,
} = BookingScreens;

export const SCREENS = {
  [SLOTS]: (data) => {
    const {
      slots,
      onSlotClick,
      onClickNavLeft,
      isLeftNavVisible,
      onClickNavRight,
      isRightNavVisible,
      onClickResetSlot,
      errorMessage,
      examCenterTimezone,
      examCenter,
      examCenterSiteId,
    } = data;
    const { bookingStore } = stores;
    const examCenterType = EXAM_CENTERS_CONFIG[examCenter];

    const [page, setPage] = useState(0);
    const [localPage, setLocalPage] = useState(0);
    const pageSize = 20;
    const maxLocalPages = window.innerWidth < 768 ? 3 : 10;
    const { bookingSessions } = bookingStore;

    const fetchBookingSessions = async (pageNumber) => {
      const fromNow = addDays(startOfDay(new Date()), pageNumber * pageSize).toISOString();
      const toDate = endOfDay(addDays(new Date(), (pageNumber + 1) * pageSize)).toISOString();

      stores.bookingStore.getBookingSessions(
        examCenterType.name,
        examCenterSiteId,
        fromNow,
        toDate,
        7,
        examCenterTimezone,
      );
    };

    const fetchNextPage = () => {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchBookingSessions(nextPage);
    };

    const onClickNavRightHandler = () => {
      if (localPage < maxLocalPages - 1) {
        setLocalPage((prevLocalPage) => prevLocalPage + 1);
      } else {
        fetchNextPage();
        setLocalPage(0);
      }
    };

    const onClickNavLeftHandler = () => {
      if (localPage > 0) {
        setLocalPage((prevLocalPage) => prevLocalPage - 1);
      }
    };

    const isMobile = window.innerWidth < 576;
    const isLeftNavButtonVisible = localPage > 0;

    return (
      <BookingCalendar
        slots={isMobile ? bookingSessions : slots}
        onSlotClick={onSlotClick}
        onClickNavLeft={isMobile ? onClickNavLeftHandler : onClickNavLeft}
        isLeftNavVisible={isMobile ? isLeftNavButtonVisible : isLeftNavVisible}
        onClickNavRight={isMobile ? onClickNavRightHandler : onClickNavRight}
        isRightNavVisible={isRightNavVisible}
        onClickResetSlot={onClickResetSlot}
        errorMessage={errorMessage}
        timeZoneName={examCenterTimezone}
        localPage={localPage}
        maxLocalPages={maxLocalPages}
      />
    );
  },
  [LICENSE_TYPE]: (data) => {
    const {
      currentSlot, onClickResetSlot, handleTypeClick, activeItem,
    } = data;
    useEffect(() => {
      gtag('event', 'old-booking-form-license-step-view', {
        event_category: 'Code de la route',
        event_label: 'Form license step',
      });
    }, []);

    return (
      <>
        <ChosenSlot onClickResetSlot={onClickResetSlot} slot={currentSlot} hasResetButton />
        <LicenseSwitcher handleTypeClick={handleTypeClick} activeItem={activeItem} />
      </>
    );
  },
  [USER_INFO]: (data) => {
    const {
      examCenter, bookSlot, currentSlot, selectedLicenseType, onEditLicenseClick,
    } = data;
    useEffect(() => {
      gtag('event', 'old-booking-form-student-info-step-view', {
        event_category: 'Code de la route',
        event_label: 'Form student info step',
      });
    }, []);

    return (
      <>
        <ChosenSlot slot={currentSlot} />
        <ChosenLicenseType
          selectedLicenseType={selectedLicenseType}
          onEditLicenseClick={onEditLicenseClick}
        />
        <LoggedInPayment examCenter={examCenter} bookSlot={bookSlot} />
      </>
    );
  },
  [REGISTRATION_TABS]: (data) => {
    const {
      onExamSigninFormSubmitHandler,
      onExamRegFormSubmitHandler,
      examCenter,
      currentSlot,
      selectedLicenseType,
      onEditLicenseClick,
    } = data;
    useEffect(() => {
      gtag('event', 'old-booking-form-sign-in-step-view', {
        event_category: 'Code de la route',
        event_label: 'Form sign in step',
      });
    }, []);

    return (
      <>
        <ChosenSlot slot={currentSlot} />
        {selectedLicenseType && (
          <ChosenLicenseType
            selectedLicenseType={selectedLicenseType}
            onEditLicenseClick={onEditLicenseClick}
          />
        )}
        <RegistrationTabs
          onExamSigninFormSubmitHandler={onExamSigninFormSubmitHandler}
          onExamRegFormSubmitHandler={onExamRegFormSubmitHandler}
          examCenter={examCenter}
        />
      </>
    );
  },
  [BOOKING_ERROR]: (data) => {
    const { onClose } = data;
    return <ErrorScreen onClose={onClose} />;
  },
  [LOADING]: () => <LoadingScreen />,
};
